import React from 'react'
import innerplus from "../Assets/innerplus.svg";
import smoothexp from "../Assets/smooth insurance experience.svg";
import writing from "../Assets/writing.svg";
import laptop from "../Assets/laptop.svg";
import desktop from "../Assets/desktop.svg";
import customPlan from "../Assets/customYou.svg";
import twoFinger from "../Assets/twohands.svg";
import expImage from "../Assets/ExpertImage.svg";
const Section2 = () => {
    return (
        <div
            className="container-fluid section_container"

        >
            <div className="row container_row"
                style={{
                    backgroundImage: `url(${innerplus})`,
                    backgroundPosition: 'center',

                    backgroundRepeat: 'no-repeat',
                }}>
                <p className="section2-heading">
                    What makes Policy Planner a favourite among people?
                </p>
                <div className="col-md-4 col-6">
                    <div className='strongPoints'>
                        <img className="Containt_section2" src={smoothexp} alt="" />
                        <p className="Containt_section2"> Smooth Insurance Experience</p>
                    </div>
                    <div className='strongPoints'>
                        <img className="Containt_section2 supportImage" src={desktop} alt="" />
                        <p className="Containt_section2">24/7 Support</p>
                    </div>
                </div>
                <div className="col-md-4 col-6">
                    <div className='strongPoints'>
                        <img className="Containt_section2" src={writing} alt="" />
                        <p className="Containt_section2">Easy Claim Assistance</p>
                    </div>
                    <div className='strongPoints'>
                        <img className="Containt_section2" src={customPlan} alt="" />
                        <p className="Containt_section2"> Custom Plans For You</p>
                    </div>
                </div>
                <div className="col-md-4 col-12">
                    <div className="row">
                        <div className="col-md-12 col-6 strongPoints">
                            <img className="Containt_section2" src={expImage} alt="" />
                            <p className="Containt_section2">Expert Guidance</p>
                        </div>
                        <div className="col-md-12 col-6 strongPoints">
                            <img className="Containt_section2" src={twoFinger} alt="" />
                            <p className="Containt_section2">Complete Protection</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Section2
